import { ProtectedPage } from 'src/layout/ProtectedPage/ProtectedPage';
import { SignUpRouter } from 'src/views/SignUpPage/SignUpRouter';

export const ProtectedPageNewUser = (<ProtectedPage><SignUpRouter /></ProtectedPage>);
